import {Typography} from "@mui/material";

export default function UserLogging({data}){
    return (
        <Typography variant={'helpText'} sx={{m: 1}}>
            Created by <b>{data.creator}</b><br/>
            Updated by <b>{data.updator}</b>
        </Typography>
    )
}